module.exports = __webpack_public_path__ + "img/portada12.4f6ee43b.png";